import { createStyles, makeStyles, Theme, fade } from '@material-ui/core/styles';
import { colorsPalette, MIDDLE_MARGIN, SMALL_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingBottom: SMALL_MARGIN,
      marginBottom: SMALL_MARGIN,
      [theme.breakpoints.up('lg')]: {
        borderBottom: `1px solid ${fade(colorsPalette.white, 0.33)}`,
        paddingBottom: MIDDLE_MARGIN,
        marginBottom: MIDDLE_MARGIN,
      },
    },
    titleWrap: {
      maxWidth: '100%',
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('md')]: {
        width: '100%',
        alignItems: 'flex-start',
      },
      [theme.breakpoints.down('sm')]: {
        paddingLeft: 24,
        paddingRight: 24,
      },
    },
    title: {
      width: '100%',
      [theme.breakpoints.up('lg')]: {
        alignItems: 'center',
        display: 'flex',
      },
    },
    navIcon: {
      display: 'block',
      padding: 6,
      height: 32,
      width: 28,
      cursor: 'pointer',
      transform: 'rotate(-90deg)',
      margin: '5px 8px 0 -10px',
    },
    cardTitle: {
      fontWeight: 'bold',
      color: colorsPalette.white,
      fontSize: 24,
      lineHeight: '28px',
      [theme.breakpoints.up('md')]: {
        fontSize: 28,
        lineHeight: '34px',
      },
      [theme.breakpoints.down('xs')]: {
        marginBottom: 0,
      },
    },
    cardSubTitle: {
      color: colorsPalette.gray,
      fontSize: 14,
      lineHeight: 1.4,
      margin: '8px 0 0 16px',
      minWidth: 100,
      [theme.breakpoints.down('md')]: {
        marginLeft: 0,
      },
    },
  }),
);

export default useStyles;
